<div appChangeFormat class="main-wrapper" [ngClass]="checkUserLoggedClass()">

  <app-search-panel *ngIf="userIsLogged"></app-search-panel>

  <div *ngIf="!userLoggedRoutes()">
    <app-header
      *ngIf="!userIsLogged"
      [userIsLogged]="userIsLogged"
      [avatarShortName]="avatarContent"
      [username]="userModel.userName"
      [userEmail]="userModel.email"
      (signInEventEmitter)="signIn()">
    </app-header>
  </div>

  <div *ngIf="userLoggedRoutes()">
    <app-header-dashboard
      [userIsLogged]="userIsLogged"
      [avatarShortName]="avatarContent"
      [username]="userModel.userName"
      [userEmail]="userModel.email"
      (sideMenuEventEmitter)="toggleSideMenu()"
      (signOutEventEmitter)="signOut()">
    </app-header-dashboard>
  </div>




  <div *ngIf="userIsLogged" (window:resize)="onResize($event)"
  [ngClass]="sideMenuStatus ? 'side-header show' : 'side-header hide'">
    <app-sidemenu
      [userRole]="userModel.roleName"
      (sideHeader)="toggleSideMenu()">
    </app-sidemenu>
  </div>


  <div class="content-body">
    <router-outlet></router-outlet>
  </div>


  <div *ngIf="!userIsLogged" class="footer-section">
    <app-footer></app-footer>
  </div>
  <div *ngIf="userIsLogged" class="footer-section footer-dashboard-section">
    <app-footer-dashboard></app-footer-dashboard>
  </div>
</div>
